module.exports = __webpack_public_path__ + "img/sql-saturday.c989e1cf.png";